import { useCallback, useEffect, useMemo } from "react";
import { useTranslation } from "react-i18next";

const DesktopReturnPage = () => {
  const { t } = useTranslation();
  const appUrl = useMemo(() => {
    const source = new URLSearchParams(window.location.search);
    const allowed = new URLSearchParams();
    for (const key of ["checkout_success", "plan", "session_id", "id"] as const) {
      const value = source.get(key);
      if (value) allowed.set(key, value);
    }
    return `onetranscribe-dictate://return?${allowed.toString()}`;
  }, []);

  const openDesktop = useCallback(() => {
    window.location.assign(appUrl);
  }, [appUrl]);

  useEffect(() => {
    // action-id: lifecycle.desktop.checkoutAutoReturn
    const timer = window.setTimeout(openDesktop, 250);
    return () => window.clearTimeout(timer);
  }, [openDesktop]);

  return (
    <main className="app-page-background fixed inset-0 flex items-center justify-center bg-[var(--bg-primary)] px-6 text-[var(--text-primary)]">
      <section className="glass w-full max-w-md rounded-3xl p-8 text-center">
        <img src="/logo.png" alt="1Transcribe" className="mx-auto mb-5 h-16 w-16 rounded-2xl" />
        <h1 className="text-2xl font-bold tracking-tight">
          {t("desktopReturn.title", { defaultValue: "Return to 1Transcribe" })}
        </h1>
        <p className="mt-3 text-[15px] text-[var(--text-secondary)]">
          {t("desktopReturn.body", {
            defaultValue: "Your browser step is complete. Continue in the desktop app.",
          })}
        </p>
        <button
          type="button"
          data-action-id="desktop.checkout.return"
          onClick={openDesktop}
          className="mt-7 w-full rounded-2xl bg-[var(--accent)] px-5 py-3.5 text-[15px] font-semibold text-[var(--text-inverse)] transition-transform active:scale-[0.98]"
        >
          {t("desktopReturn.button", { defaultValue: "Open desktop app" })}
        </button>
      </section>
    </main>
  );
};

export default DesktopReturnPage;
